import { InterviewPostsData } from '.'
import Footer from '../../components/Common/Footer'
import Interview from '../../components/components/Interview'
import Navigation from '../../components/components/Navigation'

const {
  slug,
  name,
  cover,
  index,
  post_created_at,
  title,
  avatar,
  selfBrief,
  links,
  contents,
  nextPost,
  nextPostUrl,
} = InterviewPostsData.filter((i) => i.index === 1)[0]

const InterviewAndy = () => {
  return (
    <>
      <Navigation type="soho" page="normal" />
      <Interview
        slug={slug}
        name={name}
        cover={cover}
        index={index}
        post_created_at={post_created_at}
        title={title}
        avatar={avatar}
        selfBrief={selfBrief}
        links={links}
        contents={contents}
        nextPost={nextPost}
        nextPostUrl={nextPostUrl}
      />
      <Footer />
    </>
  )
}

export default InterviewAndy
